import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";
import "datatables.net-responsive-dt";
import "datatables.net-select-dt";
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllContractTerms, deleteContractTerm } from "../../../redux/contractSlice/contractSlice";
import Swal from "sweetalert2";
import notify from "../../../hooks/useNotifaction";

DataTable.use(DT);

export default function TermsContract() {
  const [termsContract, setTermsContract] = useState([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const { allContractTerms, status } = useSelector((state) => state.contract);
  const table = useRef();

  useEffect(() => {
    dispatch(getAllContractTerms());
  }, [dispatch]);

  useEffect(() => {
    if (status === "succeeded" && allContractTerms) {
      setTermsContract(allContractTerms);
      setLoading(false);
    }
  }, [status, allContractTerms]);

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "هل أنت متأكد؟",
      text: "لن تتمكن من استرجاع هذا البند بعد الحذف!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "نعم، احذف!",
      cancelButtonText: "إلغاء",
    });

    if (result.isConfirmed) {
      setLoading(true);
      try {
        await dispatch(deleteContractTerm(id)).unwrap();
        setTermsContract((prevTerms) => prevTerms.filter((term) => term.id !== id));
        Swal.fire({
          title: "تم الحذف!",
          text: "تم حذف البند بنجاح",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
      } catch (err) {
        Swal.fire({
          title: "خطأ!",
          text: "حدث خطأ أثناء الحذف",
          icon: "error",
        });
      } finally {
        setLoading(false);
      }
    }
  };

  const screenColumns = [
    { title: "عنوان البند", data: "title" },
    { title: "وصف البند", data: "description" },
    {
      title: "عمليات",
      data: null,
      render: (data, type, row) => `
        <div class="d-flex gap-3 justify-content-center align-items-center">
          <a href="/editContractTerms/${row.id}" class="text-decoration-none">
            <i class="fa-solid fa-pen text-primary"></i>
          </a>
          <button class="delete-btn border-0 bg-transparent" data-id="${row.id}">
            <i class="fa-solid fa-trash text-danger"></i>
          </button>
        </div>
      `,
    },
  ];

  useEffect(() => {
    let mounted = true;

    if (!loading && termsContract.length > 0) {
      const handleClick = (e) => {
        const btn = e.target.closest(".delete-btn");
        if (btn) {
          const id = btn.getAttribute("data-id");
          if (id && mounted) {
            handleDelete(id);
          }
        }
      };

      document.addEventListener("click", handleClick);

      return () => {
        mounted = false;
        document.removeEventListener("click", handleClick);
      };
    }
  }, [loading, termsContract]);

  return (
    <div className="main">
      <div className="container-fluid">
        <div className="row justify-content-between align-items-center mt-3">
          <div className="col-md-4 d-flex justify-content-md-start justify-content-center mb-3">
            <div className="card py-2 px-3">
              <p className="mb-0 primary-100">عدد شروط العقد: {termsContract?.length}</p>
            </div>
          </div>
          <div className="col-md-4 text-md-end text-center">
            <Link to="/addContractTerms" className="btn btn-primary text-white">
              إضافة شرط العقد
            </Link>
          </div>
        </div>

        <div className="table-responsive" style={{ overflowX: "auto" }}>
          <div>
            <p className="text-center mb-0 fs-5">بحث</p>
          </div>

          {termsContract.length > 0 && !loading ? <DataTable data={termsContract} columns={screenColumns} className="display table table-striped table-bordered" options={{ responsive: true }} ref={table} /> : null}
        </div>
      </div>

      <style>
        {`
          .table-responsive {
            overflow-x: auto;
          }
          .delete-btn {
            cursor: pointer;
          }
          .delete-btn:hover i {
            color: #ff0000 !important;
          }
        `}
      </style>
    </div>
  );
}
